import React, { useEffect, useState } from 'react';
import './DashboardGroupTable.css';
import { useNavigate } from 'react-router-dom';
import { api, endpoints } from '../config/api';
import { Alert, Spinner, Badge } from './ui';
import { useT } from '../i18n';

const messages = {
  error: { tr: 'Hata: {msg}', en: 'Error: {msg}' },
  title: { tr: 'Gruplar', en: 'Groups' },
  colName: { tr: 'GRUP ADI', en: 'GROUP NAME' },
  colTemplate: { tr: 'ATANAN ŞABLON', en: 'ASSIGNED TEMPLATES' },
  colVisibility: { tr: 'GÖRÜNÜRLÜK', en: 'VISIBILITY' },
  templateCount: { tr: '{n} şablon', en: ({ n }) => `${n} template${n === 1 ? '' : 's'}` },
  visible: { tr: 'Görünür', en: 'Visible' },
  hidden: { tr: 'Gizli', en: 'Hidden' },
};

export default function DashboardGroupTable() {
  const [groups, setGroups] = useState([]);
  const [templateCounts, setTemplateCounts] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const { t } = useT(messages);

  useEffect(() => {
    const loadGroups = async () => {
      setLoading(true);
      setError(null);
      try {
        const [groupData, templates] = await Promise.all([
          api.get(endpoints.signatures.groups.visibility),
          api.get(endpoints.signatures.templates.list).catch(() => []),
        ]);
        setGroups(groupData);
        const counts = {};
        (templates || []).forEach(t => {
          (t.assignments || []).forEach(a => {
            counts[a.group_name] = (counts[a.group_name] || 0) + 1;
          });
        });
        setTemplateCounts(counts);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    loadGroups();
  }, []);

  if (loading) return <div className="page-loading"><Spinner /></div>;
  if (error) return <Alert variant="error">{t('error', { msg: error })}</Alert>;

  return (
    <div className="mini-table-card dashboard-group-table" onClick={() => navigate('/groups')}>
      <h2>{t('title')}</h2>
      <table className="data-table data-table-scroll">
        <thead>
          <tr>
            <th>{t('colName')}</th>
            <th>{t('colTemplate')}</th>
            <th>{t('colVisibility')}</th>
          </tr>
        </thead>
        <tbody>
          {groups.map(g => (
            <tr key={g.group_name}>
              <td>{g.group_name}</td>
              <td>{templateCounts[g.group_name] ? t('templateCount', { n: templateCounts[g.group_name] }) : '—'}</td>
              <td>
                <Badge variant={g.visible ? 'success' : 'warning'}>
                  {g.visible ? t('visible') : t('hidden')}
                </Badge>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
